import { CommImageNameComp } from "custom_modules/Members/CommonComponents";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import avatar5 from "../../assets/img/avatar_5.svg";
import File from "../../assets/img/icons/archive_normal.svg";
import Unarchive from "../../assets/img/icons/archive_primary.svg";
import Chat from "../../assets/img/icons/chat.svg";
import Bean from "../../assets/img/icons/delete_normal.svg";
import Pencil from "../../assets/img/icons/edit-2.svg";
import LocationIcon from "../../assets/img/icons/location_icon.svg";
import DotLoader from "../../components/DropdownLoader/DropdownLoader";
import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import LocationDisplay from "../../components/LocationDisplay/LocationDisplay";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import InfoTooltip from "../../components/Tooltip/InfoTooltip";
import TaskActionTooltip from "../../components/Tooltip/TaskActionTooltip";
import { ButtonIcon } from "../../styledComponents/buttons";
import {
  ClientLocationsTableHeaderContainer,
  ClientLocationsTableRowContainer,
} from "../../styledComponents/clients";
// import { useParams } from 'react-router-dom';
import {
  CommonFlex,
  CommonFlexIcon,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  FirstWordRound,
  TableText,
} from "../../styledComponents/common";
import { TableItem } from "../../styledComponents/teams";
import { IconButtonHolder } from "../Jobs/tasksStyles";
import { CommFirstRoundLetterComp } from "../Teams/CommonComponents";
import DeleteClientModal from "./DeleteClientModal";

const FirstRoundLetterComp = ({ text, backColor }) => {
  const colorList = [
    { color: "#789CFF" },
    { color: "#2C3E50" },
    { color: "#76C794" },
    { color: "#F8A14B" },
    { color: "#FE5969" },
  ];
  let selectedIndex = 0;
  if (backColor < 5) {
    selectedIndex = backColor;
  } else {
    selectedIndex = backColor % 5;
  }

  text = text.split(" ");

  return (
    <FirstWordRound
      size="40px"
      fontSize="14px"
      backColor={colorList[selectedIndex].color}
    >
      {`${text[0].slice(0, 1).toUpperCase()}${
        text[1] ? text[1].slice(0, 1).toUpperCase() : ``
      }`}
    </FirstWordRound>
  );
};

const ClientsCards = props => {
  const [clientDeleteId, setClientDeleteId] = useState("");
  const [clientList, setClientList] = useState([]);
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);
  // const { page } = useParams();
  const { t } = useTranslation();
  const orgType = props.selectedOrganization?.type || "operation";

  useEffect(() => {
    if (props.clientList && props.clientList.length > 0) {
      let list = [];
      if (props.clientType === "active") {
        list = props.clientList.filter(client => client.is_active);
      } else if (props.clientType === "archived") {
        list = props.clientList.filter(client => !client.is_active);
      }
      setClientList(list);
    } else if (props.clientList && props.clientList.length === 0) {
      setClientList([]);
    }
  }, [props.clientList, props.clientType]);

  useEffect(() => {
    if (!props.isModalOpen) {
      setClientDeleteId("");
    }
  }, [props.isModalOpen]);

  const onHoverChange = index => {
    setSelectIndex(index);
  };

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const toggle = id => {
    setClientDeleteId(id);
    props.modalToggle();
  };

  return (
    <Container  showBorder={true} marginTop="20px" style={{ paddingBottom: "20px" }}>
      {props.isLoading ? (
        <ComponentCircleLoader />
      ) : (
        <>
          <DeleteClientModal
            id={clientDeleteId ? clientDeleteId : ""}
            isOpen={props.isModalOpen}
            toggle={props.modalToggle}
            handleDelete={props.handleDelete}
          />
          {clientList && clientList.length > 0 && (
            <>
              {/* table code */}
              <ClientLocationsTableHeaderContainer>
                <TableItem>
                  <TableText>{t("customer_name")}</TableText>
                </TableItem>
                {/* <TableItem>
                  <TableText>Service Locations</TableText>
                </TableItem> */}
                <TableItem>
                  <TableText>{t("contact_number")}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>
                    {orgType === "service" ? t("jobs") : t("projects")}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText>{t("location")}</TableText>
                </TableItem>
                {/* <TableItem></TableItem> */}
                {/* <TableItem>
                  <TableText>{t("actions")}</TableText>
                </TableItem> */}
              </ClientLocationsTableHeaderContainer>
              {clientList.map((client, index) => (
                <>
                  {(props.clientUpdateLoading &&
                    props.updatingClientId === client.id) ||
                  (props.clientDeleteLoading &&
                    props.deletingClientId === client.id) ? (
                    <DotLoader loading />
                  ) : (
                    <ClientLocationsTableRowContainer>
                      <TableItem
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          props.history.push(
                            `/user/customer-details?id=${client.id}`,
                          )
                        }
                      >
                        <CommImageNameComp
                          imgSource={avatar5}
                          name={client.name}
                          size="36px"
                          fontSize="13px"
                          index={index}
                          color={client.color}
                          hoverUnderline
                          email={client.email}
                          showAddDesignation={false}
                          designation={client.designation}
                        />
                      </TableItem>

                      <TableItem
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          props.history.push(
                            `/user/customer-details?id=${client.id}`,
                          )
                        }
                      >
                        <CommonText>{client.phone_number || "-"}</CommonText>
                      </TableItem>

                      <TableItem
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          props.history.push(
                            `/user/customer-details?id=${client.id}`,
                          )
                        }
                      >
                        <CommonText>{client.workorder_count}</CommonText>
                      </TableItem>
                      <TableItem>
                        <LocationDisplay
                          locations={client.locations}
                          onClick={() =>
                            props.history.push(
                              `/user/customer-details?id=${client.id}`,
                            )
                          }
                        />
                      </TableItem>

                      {/* <TableItem></TableItem> */}

                      <TableItem>
                        {props.clientType === "active" ? (
                          <CommonFlexIcon gap="0px">
                            <IconButtonHolder
                              onMouseEnter={() => toolTipChange(1, index)}
                              onMouseLeave={() => toolTipChange(-1)}
                              onClick={() =>
                                props.history.push(
                                  `/user/edit-customer?id=${client.id}`,
                                )
                              }
                            >
                              <CommonImage
                                src={Pencil}
                                alt="pencil"
                                size="24px"
                              />
                              {selectIndex === index && toolTip === 1 && (
                                <TaskActionTooltip
                                  toolTipText={t("edit_customer")}
                                />
                              )}
                            </IconButtonHolder>

                            <IconButtonHolder
                              onMouseEnter={() => toolTipChange(2, index)}
                              onMouseLeave={() => toolTipChange(-1)}
                              onClick={() =>
                                props.handleArchive(
                                  client.id,
                                  "archive",
                                  props.PageNumber,
                                )
                              }
                            >
                              <CommonImage src={File} alt="file" size="24px" />
                              {selectIndex === index && toolTip === 2 && (
                                <TaskActionTooltip
                                  toolTipText={t("archive_customer")}
                                />
                              )}
                            </IconButtonHolder>

                            <IconButtonHolder
                              onMouseEnter={() => toolTipChange(3, index)}
                              onMouseLeave={() => toolTipChange(-1)}
                              onClick={() => toggle(client.id)}
                            >
                              <CommonImage src={Bean} alt="" size="24px" />
                              {selectIndex === index && toolTip === 3 && (
                                <TaskActionTooltip
                                  toolTipText={t("delete_customer")}
                                />
                              )}
                            </IconButtonHolder>
                          </CommonFlexIcon>
                        ) : (
                          <CommonFlexIcon gap="0px">
                            <IconButtonHolder
                              onMouseEnter={() => toolTipChange(2, index)}
                              onMouseLeave={() => toolTipChange(-1)}
                              onClick={() =>
                                props.handleArchive(
                                  client.id,
                                  "unarchive",
                                  props.PageNumber,
                                )
                              }
                            >
                              <CommonImage
                                src={Unarchive}
                                alt="file"
                                size="24px"
                              />
                              {selectIndex === index && toolTip === 2 && (
                                <TaskActionTooltip
                                  toolTipText={t("unarchive_customer")}
                                />
                              )}
                            </IconButtonHolder>
                            <IconButtonHolder
                              onMouseEnter={() => toolTipChange(3, index)}
                              onMouseLeave={() => toolTipChange(-1)}
                              onClick={() => toggle(client.id)}
                            >
                              <CommonImage src={Bean} alt="" size="24px" />
                              {selectIndex === index && toolTip === 3 && (
                                <TaskActionTooltip
                                  toolTipText={t("delete_customer")}
                                />
                              )}
                            </IconButtonHolder>
                          </CommonFlexIcon>
                        )}
                      </TableItem>
                    </ClientLocationsTableRowContainer>
                  )}
                </>
              ))}

              {/* table code finishes */}
            </>
          )}
          {!props.isLoading && clientList && clientList.length === 0 && (
            <NoDataComponent
              title={
                props.clientType === "archived"
                  ? t("no_archived_customers_found")
                  : t("no_active_customers_found")
              }
            />
          )}
        </>
      )}
    </Container>
  );
};

export default ClientsCards;
